module.exports = __webpack_public_path__ + "562c26bbb8031bc2f0282b4aca3117a8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/monsters/monster-7.png
// module id = 1693
// module chunks = 0